/**
 * Auth permissions.
 *
 * @todo Integrate into Constants.
 */
export const AUTH_PERMISSIONS = {
  'app:admin': [
    'projects:read',
    'projects:create',
    'project:read',
    'project:update',
    'project:delete',
    'project:element:create',
    'project:element:update',
    'project:element:delete',
    'project:element:logs:read',
    'project:element:contextmenu:read',
    'project:element:assignment:read',
    'project:element:comment:read',
    'project:element:comment:create',
    'project:element:comment:update',
    'project:basicarea:read',
    'project:basicarea:create',
    'project:basicarea:update',
    'project:building:create',
    'project:building:update',
    'project:building:delete',
    'project:building:cluster:create',
    'project:building:cluster:update',
    'project:building:cluster:move',
    'project:building:area:create',
    'project:building:area:update',
    'project:building:area:move',
    'project:building:area:import',
    'project:module:create',
    'project:module:update',
    'project:module:delete',
    'project:submodule:create',
    'project:submodule:update',
    'project:submodule:delete',
    'project:overview-project:read',
    'project:overview-progress:read',
    'project:overview-progress:update',
    'project:overview-team:read',
    'project:overview-team:update',
    'project:overview-comments:read',
    'project:overview-activities:read',
    'project:overview-assigned:read',
    'project:overview-download:read',
    'project:overview-arealist:read',
    'project:pdf',
    'project:excel'
  ],
  'app:application admin': [
    'projects:read',
    'projects:create',
    'project:read',
    'project:update',
    'project:delete',
    'project:element:create',
    'project:element:update',
    'project:element:delete',
    'project:element:logs:read',
    'project:element:contextmenu:read',
    'project:element:assignment:read',
    'project:element:comment:read',
    'project:element:comment:create',
    'project:element:comment:update',
    'project:basicarea:read',
    'project:basicarea:create',
    'project:basicarea:update',
    'project:building:create',
    'project:building:update',
    'project:building:delete',
    'project:building:cluster:create',
    'project:building:cluster:update',
    'project:building:cluster:move',
    'project:building:area:create',
    'project:building:area:update',
    'project:building:area:move',
    'project:building:area:import',
    'project:module:create',
    'project:module:update',
    'project:module:delete',
    'project:submodule:create',
    'project:submodule:update',
    'project:submodule:delete',
    'project:overview-project:read',
    'project:overview-progress:read',
    'project:overview-progress:update',
    'project:overview-team:read',
    'project:overview-team:update',
    'project:overview-comments:read',
    'project:overview-activities:read',
    'project:overview-assigned:read',
    'project:overview-download:read',
    'project:overview-arealist:read',
    'project:pdf',
    'project:excel'
  ],
  'app:technical consultant': [
    'projects:read',
    'projects:create'
  ],
  'app:consultant': [
    'projects:read',
    'projects:create'
  ],
  'app:project associate': [
    'projects:read'
  ],
  'project:manager': [
    'project:read',
    'project:update',
    'project:element:create',
    'project:element:update',
    'project:element:delete',
    'project:element:logs:read',
    'project:element:contextmenu:read',
    'project:element:assignment:read',
    'project:element:comment:read',
    'project:element:comment:create',
    'project:element:comment:update',
    'project:basicarea:read',
    'project:basicarea:create',
    'project:basicarea:update',
    'project:building:create',
    'project:building:update',
    'project:building:delete',
    'project:building:cluster:create',
    'project:building:cluster:update',
    'project:building:cluster:move',
    'project:building:area:create',
    'project:building:area:update',
    'project:building:area:move',
    'project:building:area:import',
    'project:module:create',
    'project:module:update',
    'project:module:delete',
    'project:submodule:create',
    'project:submodule:update',
    'project:submodule:delete',
    'project:overview-project:read',
    'project:overview-progress:read',
    'project:overview-progress:update',
    'project:overview-team:read',
    'project:overview-team:update',
    'project:overview-comments:read',
    'project:overview-activities:read',
    'project:overview-assigned:read',
    'project:overview-download:read',
    'project:overview-arealist:read',
    'project:pdf',
    'project:excel'
  ],
  'project:contributor': [
    'project:read',
    'project:element:create',
    'project:element:update',
    'project:element:delete',
    'project:element:logs:read',
    'project:element:contextmenu:read',
    'project:element:assignment:read',
    'project:element:comment:read',
    'project:element:comment:create',
    'project:element:comment:update',
    'project:basicarea:read',
    'project:basicarea:create',
    'project:basicarea:update',
    'project:building:create',
    'project:building:update',
    'project:building:delete',
    'project:building:cluster:create',
    'project:building:cluster:update',
    'project:building:cluster:move',
    'project:building:area:create',
    'project:building:area:update',
    'project:building:area:move',
    'project:building:area:import',
    'project:module:create',
    'project:module:update',
    'project:module:delete',
    'project:submodule:create',
    'project:submodule:update',
    'project:submodule:delete',
    'project:overview-project:read',
    'project:overview-progress:read',
    'project:overview-progress:update',
    'project:overview-team:read',
    'project:overview-comments:read',
    'project:overview-activities:read',
    'project:overview-assigned:read',
    'project:overview-download:read',
    'project:overview-arealist:read',
    'project:pdf',
    'project:excel'
  ],
  'project:client': [
    'project:read',
    'project:overview-project:read',
    'project:overview-progress:read',
    'project:overview-download:read',
    'project:overview-arealist:read'
  ],
  'project:contractor': [
    'project:read',
    'project:overview-project:read',
    'project:overview-download:read',
    'project:overview-arealist:read'
  ],
  'project:guest': [
    'project:read',
    'project:overview-project:read',
    'project:overview-download:read',
    'project:overview-arealist:read'
  ]
};
